import './index.css';
import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import { useLoadingState } from '@hh.ru/magritte-common-use-loading-state';
import { Skeleton } from '@hh.ru/magritte-ui-skeleton';
import { s as styles } from './styles-BHp5I8DR.js';

const CellSkeleton = ({ Component: Cell, 
// skeleton props
// width остается в cellProps
height, borderRadius, inline, additionalClass, loading, ...cellProps }) => {
    const isLoading = useLoadingState() || loading;
    if (isLoading) {
        return (jsx("div", { className: classnames({
                [styles.vertPaddingSkeleton]: cellProps.vertPadding,
                [styles.horPaddingSkeleton]: cellProps.horPadding,
            }), style: { width: cellProps.width }, children: jsx(Skeleton, { width: "100%", height: height, borderRadius: borderRadius, loading: isLoading }) }));
    }
    return jsx(Cell, { ...cellProps });
};

export { CellSkeleton };
//# sourceMappingURL=Skeleton.js.map
